import { render, staticRenderFns } from "./PermissionRole.vue?vue&type=template&id=74fb307e&scoped=true"
import script from "./PermissionRole.vue?vue&type=script&lang=js"
export * from "./PermissionRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb307e",
  null
  
)

export default component.exports